import { pdkAxios } from '@/lib/pdk-axios.ts';
import type {
  EmojiReactionAction,
  EmojiReactionPayload,
} from '@/models/types.ts';
import { useMutation } from '@tanstack/react-query';

export const useUpdateEmojiReactionsMutation = () => {
  const updateEmojiReactionsMutation = useMutation({
    mutationFn: async ({
      emojiReactionPayload,
      action,
    }: {
      emojiReactionPayload: EmojiReactionPayload;
      action: EmojiReactionAction;
    }) => {
      const response = await pdkAxios
        .post(`/emoji-reactions`, {
          id: emojiReactionPayload.id,
          emoji: emojiReactionPayload.emoji,
          action,
          reaction_to_id: emojiReactionPayload.targetId,
          reaction_to_type: emojiReactionPayload.targetType,
        })
        .catch((e) => {
          console.log('Error updating emoji reactions', e);
          throw e;
        });

      return response.data;
    },
  });

  return { updateEmojiReactionsMutation };
};
